// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","chip":"chip-2Ea0k","close":"close-3Gr7V"};